import { api } from "@/builders/axios";
import { activate_or_deactivate } from "./activate-or-deactivate";

const get = function (username: string) {
  return api.get<{
    first_name: string;
    last_name: string;
    other_names: string;
    phone_number: string;
    email: string;
    subject_ids: Array<number>;
    utme_number: string;
  }>(`/students/${username}`);
};

const put = function (
  username: string,
  data: {
    first_name: string;
    last_name: string;
    other_names: string;
    phone_number: string;
    email: string;
  }
) {
  return api.put(`/students/${username}`, data);
};

const patch = function (
  username: string,
  data: Partial<{
    first_name: string;
    last_name: string;
    other_names: string;
    phone_number: string;
    email: string;
  }>
) {
  return api.patch(`/students/${username}`, data);
};

const del = function (username: string) {
  return api.delete(`/students/${username}`);
};

export const username = {
  get,
  put,
  patch,
  del,
  activate_or_deactivate,
};
